import React, { useContext } from 'react';
import Box from '../single_component/Box';
import Text from '../single_component/Text';
import Image from '../single_component/Image';
import HiHand from '../../assets/HiHand.png';
import ProfileContext from '../../context/ProfileContext';
import StringUtils from '../../utils/stringUtil';
function SalesWelcomeBox() {
  const { ProfileData } = useContext(ProfileContext);
  const { user } = ProfileData || {};

  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'space-between',
      }}>
      <Box style={{ display: 'flex', alignItems: 'center' }}>
        <Text
          style={{
            fontSize: 32,
            fontWeight: '600',
          }}>
          Welcome back, {StringUtils.capitalizeFirstLetter(user?.name)}
        </Text>
        <Image
          src={HiHand}
          style={{
            width: 32,
            height: 32,
            objectFit: 'cover',
            marginLeft: '10px',
          }}
        />
      </Box>
    </Box>
  );
}

export default SalesWelcomeBox;
